import React, { useState, useEffect } from 'react';

import { TemplatePreview } from '@confluence/template-preview/entry-points/TemplatePreview.ts';
import { useEditorWidthObserver } from '@confluence/editor-features/entry-points/useEditorWidthObserver.ts';

import {
	BlankPageQuickActionsTemplatePreviewContainer,
	BlankPageQuickActionsTemplatePreviewWrapper,
} from './bpqaStyled.tsx';
import { useBlankPageQuickActionsContext } from './BlankPageQuickActionsContext.tsx';

type BlankPageQuickActionsTemplatePreviewProps = {
	spaceKey: string;
};

export const BlankPageQuickActionsTemplatePreview = ({
	spaceKey,
}: BlankPageQuickActionsTemplatePreviewProps): React.JSX.Element | null => {
	const [previewHovered, setPreviewHovered] = useState<boolean>(false);
	const { templates, templateIndex, buttonHovered } = useBlankPageQuickActionsContext();

	const shouldShowTemplatePreview = buttonHovered || previewHovered;

	const { width } = useEditorWidthObserver({});

	useEffect(() => {
		// we need to preload the TemplatePreview
		// component or the rendering will flicker between
		// skeleton & loaded states
		void TemplatePreview.preload();
	}, []);

	return shouldShowTemplatePreview ? (
		<BlankPageQuickActionsTemplatePreviewWrapper>
			<BlankPageQuickActionsTemplatePreviewContainer
				editorWidth={width}
				shouldShowTemplatePreview={shouldShowTemplatePreview}
				onMouseEnter={() => {
					setPreviewHovered(true);
				}}
				onMouseLeave={() => {
					setPreviewHovered(false);
				}}
				data-testid="bpqa-full-size-template-preview-container"
			>
				<TemplatePreview
					spaceKey={spaceKey}
					templates={templates.map((template) => ({
						name: template.name ?? null,
						contentBlueprintId: template.contentBlueprintId ?? null,
						templateId: template.templateId ?? null,
						blueprintModuleCompleteKey: template.blueprintModuleCompleteKey ?? null,
						itemModuleCompleteKey: template.itemModuleCompleteKey ?? null,
						iconURL: template.iconURL ?? null,
						darkModeIconURL: template.darkModeIconURL,
						styleClass: template.styleClass ?? null,
					}))}
					currentTemplateIndex={templateIndex}
					numPreviewsToFetchAtOnce={3}
				/>
			</BlankPageQuickActionsTemplatePreviewContainer>
		</BlankPageQuickActionsTemplatePreviewWrapper>
	) : null;
};
